<template>
  <div>
    <div v-for="(page, index) in pageGroupedElements" :key="'page-' + index" class="position-relative dinA4">
      <img :src="require('@/assets/insular-header.png')" class="mb-0 page__header" />
      <div class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex">
          <div v-if="element.type === 'table'" class="d-flex justify-center" :class="{ 'mt-10': elementIndex > 0 }">
            <PdfProductTable v-for="(id, i) in element.ids" :key="'table-' + i" :type="element.tableType"
              :tableData="productTableList[id]" :tableId="id" :image="i === 0 && element.imageUrl" />
          </div>
          <div v-else class="d-flex justify-center mt-5">
            <div :class="element.extraWide ? 'small-letter-section-extrawide' : 'small-letter-section'">
              <p class="small-letter-font small-letter-font--bold mb-0">
                {{ element.intro }}
              </p>
              <ul class="small-letter-font justify-text spaced-list">
                <li v-for="(elementList, listIndex) in element.list" :key="'elementList' + listIndex"
                  v-html="elementList" />
              </ul>
              <p v-if="element.outro" class="small-letter-font justify-text mt-6 mb-0" v-html="element.outro" />
            </div>
          </div>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2025/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025/Footer'

export default {
  name: 'InsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/cttcanarias-icon.png'),
          ids: ['CANEXPRESS', 'CANECOMMERCE'],
          tableType: 'cannary',
        },
        {
          type: 'table',
          ids: ['CANMARITIMO'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          relatedTableType: 'cannary',
          extraWide: true,
          intro: 'Características de los servicios CTT Canarias (LPA - TNF / Resto de Islas):',
          list: [
            '- Peso máximo por bulto: 30 kg.',
            '- Medidas máximas por bulto: suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3 aéreo y 333 kg/m3 marítimo.',
            '- CTT Canarias Documentación: Entrega en 24h. Servicio válido solo para envíos de documentación.',
            '- CTT Canarias Aéreo: Entrega en 48h TLF y LPA  y 72h Islas Menores. Incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
            '- CTT Canarias Marítimo: Entrega en 7 días. El servicio “Islas Mayores” e “Islas Menores” incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          ids: ['BALEXPRESS', 'BALECONOMY'],
          tableType: 'balear',
        },
        {
          type: 'text',
          relatedTableType: 'balear',
          extraWide: true,
          intro: 'Características de los servicios CTT Baleares (Mallorca / Resto de Islas):',
          list: [
            '- Peso máximo por bulto: 30 kg.',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167 kg/m3 aéreo y 333 kg/m3 marítimo.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttotherdest-icon.png'),
          ids: ['OTHERDESTINATIONS'],
          tableType: 'otherDestinations',
        },
        {
          type: 'text',
          relatedTableType: 'otherDestinations',
          extraWide: true,
          intro:
            'Características de los servicios Ceuta, Melilla, Gibraltar, Andorra e Islas Portugal:',
          list: [
            '- Peso máximo por bulto: 30 kg (Islas Portugal Aéreo: Madeira hasta 20kg; Azores hasta 5kg).',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3 (Ceuta, Melilla e Islas Portugal Marítimo 333 kg/m3).',
            '- Impuestos e IVA no incluidos. Ver página de Servicios Aduaneros.',
            '- Islas Portugal: no es necesario documentación adicional(Territorio intracomunitario).',
          ],
        },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let doubleRow = false
      let rowElementCounter = 0

      for (let i = 0; i < this.elements.length; i++) {
        let actualElement = this.elements[i]
        if (actualElement.type !== 'text') {
          for (const id of actualElement.ids) {
            const numberOfRows = Object.keys(this.productTableList[id].kgRows).length

            if (numberOfRows > 15) {
              singleRow = true
            } else if (numberOfRows > 7) {
              doubleRow = true
            }
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else if (doubleRow) {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter === 2 || rowElementCounter === this.elements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (
            (rowElementCounter === 2 &&
              actualElement.type === 'text' &&
              actualElement.relatedTableType === 'cannary' &&
              this.elements.filter(
                element => element.type === 'table' && element.tableType === 'cannary',
              ).length === 1) ||
            (rowElementCounter === 3 && actualElement.type !== 'table') ||
            (rowElementCounter === 4 &&
              actualElement.type === 'text' &&
              actualElement.relatedTableType !== ' balear') ||
            rowElementCounter === this.elements.length
          ) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }
      return pages
    },
  },
  created() {
    this.$emit('updateTotalPages', { InsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularTables')
  },
}
</script>
